<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row" v-if="false">
                <div class="col-6">
                <form action="#">
                    <div class="input-group">
                        <input type="search" class="form-control form-control" placeholder="Cari Mata Pelajaran">
                        <div class="input-group-append">
                            <button type="submit" class="btn btn btn-default">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                </form>
                </div>
            </div>
            <br>
            <div class="row">
                <div v-for="row in optMapel" v-bind:key="row.mapel_id"
                v-bind:value="row.mapel_id" class="col-md-4 col-sm-8 col-12">
                <router-link :to="{ path: '/ujian-mapel-list/'+row.mapel_id+'/latihan' }">
                    <div class="info-box shadow-sm">
                    <span class="info-box-icon bg-warning"><i></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text">{{ row.mapel }}</span>
                        <span class="info-box-number">{{ row.qty_ujian }} Soal Latihan</span>
                    </div>
                    </div>
                </router-link>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { authFetch } from "@/libs/hxcore";
export default {
    name: 'SoalMapel',
    data: () => ({
        optMapel: [],
        filter: {},
    }),
    created: function () {
        if(this.$route.params.filter) {
        this.filter = this.$route.params.filter;
        }
        
        if(Object.keys(this.filter).length<1)
        {
        if(sessionStorage.filterData)this.filter = JSON.parse(sessionStorage.filterData);
        }
        else{
        sessionStorage.filterData = JSON.stringify(this.filter);
        sessionStorage.filterStatus = 1;
        }

        this.loadLatihan(this.filter);
    },
    methods: {
        loadLatihan(params){
            let data = '';
            data = Object.keys(params)
            .map(
            (key) =>
                encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
            )
            .join("&");
            authFetch("/tentor/ujian/latihan_list?"+data).then((res) => {
                res.json().then((json) => {
                if (json.success) {
                    this.optMapel = json.data;
                }
                });
            });
        }
    },
    mounted(){
        // this.loadLatihan();
    },
}
</script>
<style type="text/css" scoped>
</style>